module.exports = __webpack_public_path__ + "img/pic-TAKIYA.724d6b52.png";